export const defaultVariables = ['fullname'];
